import moment from "moment";
import React from "react";
import { Container } from "react-bootstrap";
import { IconLogo } from "../../utils/icons";
import { Link, useLocation } from "react-router-dom";

const AuthLayout = ({ children, loginLink, linkText, onLinkClick, alert, className = "" }) => {
  const currentYear = moment().format("YYYY");
  const location = useLocation();
  const shouldHideLogo = location.pathname === "/password_changed" || location.pathname === "/account_blocked";

  return (
    <>
      <div className="login-container">
        <Container>
          <div className={`${className}`}>
            {!shouldHideLogo && (
              <div className="login-logo text-center">
                <IconLogo className="app-logo" />
              </div>
            )}
            {children}
          </div>
          {loginLink && linkText && (
            <div
              className="login-link"
              onClick={() => {
                onLinkClick?.();
              }}
            >
              <Link to={loginLink}>{linkText}</Link>
            </div>
          )}
        </Container>
        <div>
          <p className="copyright-text">
            Copyright © {currentYear} {process.env.REACT_APP_TITLE}
          </p>
        </div>
      </div>
      {alert}
    </>
  );
};

export default AuthLayout;
